import { resetPage } from '../utils/resetPage';

const wpReset = () => resetPage('_db');

export {
    wpReset
}